var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSurvey = function SvgSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 2 \\u2013 1",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 61",
    width: 119.088,
    height: 39,
    rx: 6.5,
    fill: "#fff",
    stroke: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(7.5 6.5)",
    fill: "#f8f8fa"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "$1.65",
    transform: "translate(44.566 29.005)",
    fill: "#2bd675",
    fontSize: 11,
    fontFamily: "Metropolis-Bold, Metropolis",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$1.65")), /*#__PURE__*/React.createElement("text", {
    "data-name": "$1.50",
    transform: "translate(44.566 17.005)",
    fontSize: 11,
    fontFamily: "Metropolis-Bold, Metropolis",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$1.50")), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 4",
    fill: "none",
    stroke: "red",
    d: "m44.066 17.5 31-7"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "10%",
    transform: "translate(81.566 23)",
    fill: "#2cda77",
    fontSize: 12,
    fontFamily: "Metropolis-Bold, Metropolis",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+10%")))));
};
export default SvgSurvey;